import FUpload from './FUpload.vue'

export default FUpload